import React, { useState } from "react";
import { addNewDoc } from "../../../utils/firebase/Firebase.utils";
import InputBox from "../Components/InputBox";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import {
  FiBox,
  FiMap,
  FiUser,
  FiAlignLeft,
  FiTag,
  FiPackage,
  FiHash,
  FiX,
  FiSave,
} from "react-icons/fi";

export default function NewInventoryForm({ setAddMode }) {
  const [formData, setFormData] = useState({});
  const [isProcessing, setIsProcessing] = useState(false);

  const currentUser = useSelector((state) => state.userObject);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsProcessing(true);
    const docObject = {
      ...formData,
      createdAt: new Date().toLocaleString(),
      createdBy: currentUser.uid,
      createdName: currentUser.displayName,
      createdEmail: currentUser.email,
      updateType: "new inventory item created",
    };

    await addNewDoc("inventory", docObject);
    toast.success("New Inventory Item Successfully Created");
    setAddMode(false);
    setIsProcessing(false);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Colors based on requirements
  const primaryColor = "#363062";
  const secondaryColor = "#8FCD00";

  return (
    <div className="bg-white rounded-xl shadow-lg relative p-6 max-w-md w-full mx-auto">
      {/* Header */}
      <div className="flex justify-between items-center mb-6 pb-4 border-b border-gray-100">
        <div className="flex items-center gap-2">
          <div
            className="p-2 rounded-lg"
            style={{ backgroundColor: `${primaryColor}10` }}
          >
            <FiPackage style={{ color: primaryColor }} />
          </div>
          <h2 className="text-lg font-semibold" style={{ color: primaryColor }}>
            Add New Inventory Item
          </h2>
        </div>
        <button
          onClick={() => setAddMode(false)}
          className="p-2 rounded-full hover:bg-gray-100 transition-colors"
        >
          <FiX className="text-gray-500" />
        </button>
      </div>

      <div className="overflow-y-auto max-h-[70vh] pr-2 -mr-2">
        <form className="space-y-4">
          <div className="text-sm text-gray-500 mb-2 font-medium">
            Item Information
          </div>

          <div className="flex gap-2 items-center w-full">
            <div className="text-gray-400 self-start pt-7">
              <FiBox size={16} />
            </div>
            <div className="w-full">
              <InputBox
                label="Item Name"
                name="itemName"
                placeholder="Enter item name"
                onChange={handleChange}
                type="text"
                required
                disabled={isProcessing}
                className="w-full"
              />
            </div>
          </div>

          <div className="flex gap-2 items-center w-full">
            <div className="text-gray-400 self-start pt-7">
              <FiTag size={16} />
            </div>
            <div className="w-full">
              <InputBox
                label="Category"
                name="category"
                placeholder="Enter item category"
                onChange={handleChange}
                type="text"
                required
                disabled={isProcessing}
                className="w-full"
              />
            </div>
          </div>

          <div className="flex gap-2 items-center w-full">
            <div className="text-gray-400 self-start pt-7">
              <FiAlignLeft size={16} />
            </div>
            <div className="w-full">
              <InputBox
                label="Description"
                name="description"
                placeholder="Enter Description"
                onChange={handleChange}
                type="text"
                required
                disabled={isProcessing}
                className="w-full"
              />
            </div>
          </div>

          <div className="pt-2 border-t border-gray-100">
            <div className="text-sm text-gray-500 mb-2 font-medium">
              Location Information
            </div>
          </div>

          <div className="flex gap-2 items-center w-full">
            <div className="text-gray-400 self-start pt-7">
              <FiMap size={16} />
            </div>
            <div className="w-full">
              <InputBox
                label="Location"
                name="location"
                placeholder="Enter location of item"
                onChange={handleChange}
                type="text"
                required
                disabled={isProcessing}
                className="w-full"
              />
            </div>
          </div>

          <div className="flex gap-2 items-center w-full">
            <div className="text-gray-400 self-start pt-7">
              <FiUser size={16} />
            </div>
            <div className="w-full">
              <InputBox
                label="Custodian"
                name="custodian"
                placeholder="Enter name of custodian"
                onChange={handleChange}
                type="text"
                required
                disabled={isProcessing}
                className="w-full"
              />
            </div>
          </div>

          <div className="pt-2 border-t border-gray-100">
            <div className="text-sm text-gray-500 mb-2 font-medium">
              Quantity Information
            </div>
          </div>

          <div className="flex gap-2 items-center w-full">
            <div className="text-gray-400 self-start pt-7">
              <FiHash size={16} />
            </div>
            <div className="w-full">
              <InputBox
                label="Quantity"
                name="quantity"
                placeholder="Enter initial quantity"
                onChange={handleChange}
                type="number"
                required
                disabled={isProcessing}
                className="w-full"
              />
            </div>
          </div>

          <div className="pt-4 mt-2">
            <button
              className="w-full py-2.5 px-4 rounded-lg flex items-center justify-center gap-2 transition-colors"
              style={{ backgroundColor: secondaryColor, color: "white" }}
              onClick={handleSubmit}
              disabled={isProcessing}
              type="submit"
            >
              {isProcessing ? (
                <>
                  <div className="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full"></div>
                  <span>Processing...</span>
                </>
              ) : (
                <>
                  <FiSave size={16} />
                  <span>Save Inventory Item</span>
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
